import { createSelector } from 'reselect';
import { statsLeadersSelector } from './simple-selectors';

export const statsLeadersEmptyRequestsSelector = createSelector(
    statsLeadersSelector,
    (statsLeaders) => statsLeaders.emptyRequests
);
